import React, { Component } from 'react'
import { translation } from '../../../../utils/helpers'

// Line components
import PriceLine from './../PriceLine'
import EstimationLine from './../EstimationLine'
import ComplaintLine from './../ComplaintLine'
import DeviationLine from './../DeviationLine'
import OtherDamageLine from './../OtherDamageLine'

import './part.scss'

class Part extends Component {
  render () {
    let tasks = this.props.part.Tasks
    let estimationTasks = this.props.part.EstimationTasks
    let complaints = this.props.part.Complaints
    let deviationReasons = this.props.part.DeviationReasons
    let customDeviationReasons = this.props.part.CustomDeviationReasons
    let otherDamages = this.props.part.OtherDamages

    if (this.props.includeForsiAssociatedTasks === undefined || this.props.includeForsiAssociatedTasks === false) {
      if (estimationTasks && estimationTasks.length > 0 && estimationTasks.filter(x => x.PaintLineId < 1).length === 0) return null
    }

    if (this.props.onlyAdditionalParts && !this.props.part.IsAdditional) return null
    let partName = translation(this.props.part.Part.DictionaryKey)
    let side = null
    let frontBack = null

    if (this.props.part.Part.TaskSide !== 0) {
      switch (this.props.part.Part.TaskSide) {
        case 1:
          side = translation('213')  // Left
          break
        case 2:
          side = translation('214')  // Right
          break
        case 5:
          side = translation('213')  // Left
          frontBack = translation('287') // Front
          break
        case 6:
          side = translation('214')  // Right
          frontBack = translation('287') // Front
          break
        case 7:
          side = translation('213')  // Left
          frontBack = translation('288') // Back
          break
        case 8:
          side = translation('214')  // Right
          frontBack = translation('288') // Back
          break
      }
    }

    let partAndLocation = ''
    if (side !== null) partAndLocation += side + ' '
    partAndLocation += partName + ' '
    if (frontBack !== null) partAndLocation += frontBack

    if (partAndLocation.trim() === '') {
      partAndLocation = translation(227) // Other
    }

    let pNumber = this.props.part.Part.PNumber ? ' (' + this.props.part.Part.PNumber + ')' : ''

    const renderOrderTaskPrice = (item, key) => {
      if (item.OrderTaskId === undefined || item.IsDeleted) return null
      return <PriceLine
        {...this.props}
        key={'task_' + (item.OrderTaskId || key)}
        orderTaskPrice={item}
        noPrice={this.props.noPrice}
        />
    }

    const renderOrderEstimationTasks = (item, key) => {
      if (item.OrderEstimationTaskId === undefined || item.IsDeleted) return null

      if ((this.props.includeForsiAssociatedTasks === undefined || this.props.includeForsiAssociatedTasks === false) && item.PaintLineId > 0) return null
      return <EstimationLine
        {...this.props}
        key={'estimationtask_' + (item.OrderEstimationTaskId || key)}
        orderEstimationTask={item}
        />
    }

    const renderComplaints = (item, key) => {
      if (item === undefined || item.IsDeleted) return null
      return <ComplaintLine
        {...this.props}
        key={'complaint_' + (item.ComplaintType || key)}
        complaint={item}
        />
    }

    const renderDeviationReasons = (item, key) => {
      if (item === undefined || item.IsDeleted) return null
      return <DeviationLine
        {...this.props}
        key={'deviation_' + (item.DeviationReasonId || key)}
        reason={item}
        />
    }

    const renderCustomDeviationReasons = (item, key) => {
      if (item === undefined || item.IsDeleted) return null
      return <DeviationLine
        {...this.props}
        key={'deviation_' + (item.CustomDeviationReasonId || key)}
        isCustomReason
        reason={item}
        />
    }

    const renderOtherDamage = (item, key) => {
      if (item === undefined || item.IsDeleted) return null
      return <OtherDamageLine
        {...this.props}
        key={'otherDmg_' + (item.Id || key)}
        damage={item}
      />
    }

    // let key = this.props.part.PartItemId + '_' + this.props.part.PartSide
    if (partAndLocation.includes('undefined')) return null
    return (
      <div>
        <div className='partname'>{partAndLocation !== undefined ? partAndLocation : ''}{pNumber !== undefined ? pNumber : ''}</div>
        {tasks !== undefined && tasks.map(renderOrderTaskPrice)}
        {complaints !== undefined && complaints.map(renderComplaints)}
        {estimationTasks !== undefined && estimationTasks.map(renderOrderEstimationTasks)}
        {deviationReasons !== undefined && deviationReasons.map(renderDeviationReasons)}
        {customDeviationReasons !== undefined && customDeviationReasons.map(renderCustomDeviationReasons)}
        {otherDamages !== undefined && otherDamages.map(renderOtherDamage)}
      </div>
    )
  }
}

Part.contextTypes = {
  router: React.PropTypes.object.isRequired
  // enum: React.PropTypes.func.isRequired
}

export default Part



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Part/index.js